/*
 * DO NOT EDIT js/compiled/ai-display.js
 * ALL EDITING IS DONE IN js/src/ai-display.js AND COMPILED WITH BABEL
 * grunt or grunt compile
*/

'use strict';

// Ad
class AI_Ad {
    constructor() {
        this.ad = document.getElementById('ad-inner-wrapper');
        let cookies = get_cookies();
        let close_button = document.getElementById('ad-close');

        if(this.ad !== null && (!close_button || (!cookies.ad || (cookies.ad && cookies.ad != 'hide')))) {
            // Show the add
            this.ad.classList.add('ad-visible');
            let last_visible_panel = last_visible_element(document.getElementById('content-wrapper'));
            if(last_visible_panel) {
                last_visible_panel.classList.add('ad-padding');
            }
            // Set up close button
            if(close_button) {
                close_button.addEventListener('click', this.close);
            }
        } else if(this.ad !== null) {
            // Remove the ad
            this.ad.remove();
        }
    }
    close(e) {
        let ad = e.currentTarget.parentElement;
        ad.remove();
        document.getElementsByClassName('ad-padding')[0].classList.remove('ad-padding');
        document.cookie = 'ad=hide;path=/;max-age=' + 24*60*60;;
    }
}
const ai_ad_init = function() {
    new AI_Ad();
};
ai_document_ready(ai_ad_init);

class AI_Animation {
    constructor()  {
        let animations = document.getElementsByClassName('ai-animation-wrapper');
        for(let i = 0; i < animations.length; i++) {
            let animation = animations[i];
            let function_name = animation.getAttribute('data-init');
            if(typeof window[ function_name ] == 'function') {
                eval(function_name+'()');
            }
        }
    }
}
const ai_animation_init = function() {
    new AI_Animation();
};
ai_document_ready(ai_animation_init);

// Back to Top
class AI_Back_to_Top {
    constructor() {
        this.button_id = 'ai-to-top';
        // Button
        if(! document.getElementById(this.button_id)) {
            this.button();
        }
        // On scroll
        document.removeEventListener('scroll', this.on_scroll);
        document.addEventListener('scroll', this.on_scroll);
        this.on_scroll();
    }

    button = () => {
        let back_to_top_button = document.createElement('button');
        back_to_top_button.setAttribute('id', this.button_id);
        back_to_top_button.setAttribute('title', 'Scroll To Top');
        back_to_top_button.innerHTML = '<span>To Top</span>';
        document.body.appendChild(back_to_top_button);
        back_to_top_button.addEventListener('click', this.button_on_click);
    }

    button_on_click = () => {
        window.scrollTo(0, 0);
    }

    on_scroll = () => {
        let ai_to_top = document.getElementById(this.button_id);
        let window_scroll_y = window.scrollY;
        let window_height = window.innerHeight;
        let button_action = window_scroll_y > (window_height * 1.5) ? 'show' : 'hide';
        if(button_action == 'show') {
            ai_to_top.classList.add('show');
        } else if(button_action == 'hide') {
            ai_to_top.classList.remove('show');
        }
    }
}
const ai_back_to_top_init = function() {
    new AI_Back_to_Top();
};
ai_document_ready(ai_back_to_top_init);

class AI_Content_Survey {
    constructor() {
        let content_surveys = Array.from(document.getElementsByClassName('content-survey'));
        if(content_surveys) { 
            content_surveys.forEach(survey => {
                let survey_buttons = Array.from(survey.getElementsByTagName('button'));
                if(survey_buttons.length) {
                    survey_buttons.forEach(button => {
                        button.addEventListener('click', this.survey_submit);
                    });
                }
            });
        }
    }
    survey_submit = (e) => {
        let button = e.target;
        let answer = button.getAttribute('data-value');
        let post_id = button.getAttribute('data-post-id');
        button.parentElement.classList.add('loading');
        // Post the response
        fetch(`${home_url}/content-survey/post/${post_id}/answer/${answer}`, {
            method: 'POST',
        })
        .then(result => {
            button.parentElement.classList.remove('loading');
            button.parentElement.innerHTML = '<p>Thanks for your feedback!</p>';
        });
    }
}
const ai_content_survey_init = function() {
    new AI_Content_Survey();
};
ai_document_ready(ai_content_survey_init);

// 'Counts up' to a number, starting from 0. Can also count down if 'down' class is added to the element, using 'down-from' attribute as the starting point
const ai_count_up = function() {
    let count_me = document.getElementsByClassName('count-up');
    if(count_me) {
        for(let i = 0; i < count_me.length; i++) {
            let count_element = count_me[i];
            count_element.setAttribute('uk-scrollspy', '');
            let count_number = Number(count_element.textContent);
            let count_options = {
                duration: 2,
                easingFn: function (t, b, c, d) { // from https://inorganik.github.io/countUp.js/
                    let ts = (t /= d) * t;
                    let tc = ts * t;
                    return b + c * (tc + -3 * ts + 3 * t);
                }
            };
            if (count_element.classList.contains('decimal')) {
                count_options.decimalPlaces = 1;
            }
            if (count_element.classList.contains('down')) {
                count_options.startVal = count_element.getAttribute('data-from');
            }
            let count_up_init = new CountUp(count_element, count_number, count_options);
            if (!count_up_init.error) {
                UIkit.util.on(count_element, 'inview', function() {
                    count_up_init.start();
                });
            }
        }
    }
}
ai_document_ready(ai_count_up);

const ai_date_countdown = function() {
    let countdowns = document.getElementsByClassName('date-countdown');
    if(countdowns) {
        for(let i = 0;i < countdowns.length;i++) {
            let date_element = countdowns[i];
            let date_raw = new Date(Number(date_element.getAttribute('data-date')) * 1000); // convert to milliseconds
            let date = date_raw.getTime(); // date is in UTC, so no further convertion is needed
            let date_element_parent_section = get_parent(date_element, 'section');
            let now_raw = new Date();
            let now = now_raw.getTime();
            // Make sure we want to show the panel (hide 30 minutes after start time)
            if ( date + 1800000 > now ) {
                // Update the count down every 1 second
                let countdown = setInterval(function() {
                    now_raw = new Date();
                    now = now_raw.getTime();
                    let distance = date - now > 0 ? date - now : 0;
                    // Time calculations for days, hours, minutes and seconds
                    let days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
                    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
                    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
                    let seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');
                    let days_label = translate.Days;
                    let hours_label = translate.Hours;
                    let minutes_label = translate.Minutes;
                    let seconds_label = translate.Seconds;

                    // Display the result
                    date_element.innerHTML = `<span class="number-wrapper">
                        <span class="number">${days}</span>
                        <span class="label">${days_label}</span>
                    </span>
                    <span class="number-wrapper">
                        <span class="number">${hours}</span>
                        <span class="label">${hours_label}</span>
                    </span>
                    <span class="number-wrapper">
                        <span class="number">${minutes}</span>
                        <span class="label">${minutes_label}</span>
                    </span>
                    <span class="number-wrapper">
                        <span class="number">${seconds}</span>
                        <span class="label">${seconds_label}</span>
                    </span>`;

                    // Stop the script when distance hits zero
                    if(distance == 0) {
                        clearInterval(countdown);
                    }
                }, 1000);

                // Slide up on load
                date_element_parent_section.classList.add('uk-animation-fade');
            }
            // Hide the panel if the time has passed
            else {
                date_element_parent_section.style.display = 'none';
            }
        }
    }
}
ai_document_ready(ai_date_countdown);

class AI_Downloadable_Contact_Button {
    constructor() {
        this.downloadable_contact_button = document.getElementById('downloadable-contact-button');
        if(this.downloadable_contact_button) {
            this.get_info();
            this.downloadable_contact_button.addEventListener('click', this.on_click);
        }
    }
    get_info = () => {
        this.iframe_name = this.downloadable_contact_button.getAttribute('target');
        this.iframe = document.getElementsByName(this.iframe_name)[0];
        this.content_url = this.iframe.getAttribute('src');
        this.current_state = 'pdf';
        this.contact_href = this.downloadable_contact_button.getAttribute('href');
        this.contact_label = this.downloadable_contact_button.innerHTML;
    }
    on_click = (e) => {
        e.preventDefault();
        let anchor_element = e.currentTarget;
        if(this.current_state == 'pdf') {
            this.iframe.setAttribute('src', this.contact_href)
            anchor_element.innerHTML = 'Back to PDF';
            this.current_state = 'form';
        } else if(this.current_state == 'form') {
            this.iframe.setAttribute('src', this.content_url)
            anchor_element.innerHTML = this.contact_label;
            this.current_state = 'pdf';
        }
    }
}
const ai_downloadable_contact_button_init = function() {
    new AI_Downloadable_Contact_Button();
};

class AI_Events {
    constructor() {
        let events = document.getElementsByClassName('ai-event');
        if(events.length) {
            for(let i = 0; i < events.length; i++) {
                this.event_appearance(events[i]);
            }
        }
    }
    event_appearance(event) {
        let type = event.getAttribute('data-event-type');
        let date_raw = new Date(Number(event.getAttribute('data-event-date')) * 1000);
        let date = date_raw.getTime();
        let now_raw = new Date();
        let now = now_raw.getTime();
        let event_past = date + (30 * 60 * 1000) < now; // 30 minutes later
        let event_replay = date + (48 * 60 * 60 * 1000) < now; // 48 hours later
        // Webinars and Hybrid - remove them (it's temporary... they are reinstated in 48 hours via the template)
        if((type == 'webinar' || type == 'hybrid') && event_past) {
            if(!event_replay) {
                event.remove();
            } else {
                // Date
                let event_dates = event.getElementsByClassName('ai-event-date');
                if(event_dates) {
                    event_dates[0].remove();
                }
                // Location
                let event_locations = event.getElementsByClassName('ai-event-location');
                if(event_locations) {
                    event_locations[0].remove();
                }
                // Registration buttons
                let registration_buttons = event.getElementsByClassName('ai-event-register');
                if(registration_buttons) {
                    registration_buttons[0].textContent = 'Watch the Replay';
                }
                // Past event class
                event.classList.add('past-event');
            }
        }
        // In Person - remove the register button
        else if(type == 'in-person' && event_past) {
            let registration_buttons = event.getElementsByClassName('ai-event-register');
            if(registration_buttons) {
                registration_buttons[0].remove();
            }
            event.classList.add('past-event');
        }
    }
}
const ai_events_init = function() {
    new AI_Events();
};
ai_document_ready(ai_events_init);

class AI_Form {
    constructor() {
        let ai_forms = document.getElementsByClassName('ai-form');
        for(let i = 0; i < ai_forms.length; i++) {
            ai_forms[i].addEventListener('submit', this.on_submit);
        }
    }
    on_submit(e) {
        e.preventDefault();
        let form = this;
        let form_data = new FormData(form);
        let form_id = form.getAttribute('id');
        form.classList.add('loading');
        fetch(form.getAttribute('action'), {
            method: form.getAttribute('method'),
            body: form_data
        })
        .then(response => response.text())
        .then((text) => {
            // If a DOM is returned
            if(text.indexOf('<html') > -1) {
                let parser = new DOMParser();
                let htmlDocument = parser.parseFromString(text, "text/html");
                if(htmlDocument.getElementById(form_id)) {
                    document.getElementById(form_id).innerHTML = htmlDocument.getElementById(form_id).innerHTML;
                }
            }
            // If a message is returned
            else {
                let response = JSON.parse(text);
                // A Thank You message
                if(response.thank_you_message) {
                    let thank_you = response.thank_you_message;
                    document.getElementById(form_id).innerHTML = `<p class="small">${thank_you}</p>`;
                }
                // A redirect
                if(response.redirect_url) {
                    window.location = response.redirect_url;
                }
            }
            form.classList.remove('loading');
        });
    }
}
const ai_form_init = function() {
    new AI_Form();
}
ai_document_ready(ai_form_init);

// Form Fields
class AI_Form_Fields {
    constructor() {
        this.range_slider();
    }

    range_slider() {
        let range_slider_containers = document.getElementsByClassName('range-slider-container');
        if(range_slider_containers.length) {
            for(let i = 0; i < range_slider_containers.length; i++) {
                let range_slider = range_slider_containers[i].getElementsByClassName('range-slider')[0];
                let plus_button = range_slider_containers[i].getElementsByClassName('range-slider-plus')[0];
                let minus_button = range_slider_containers[i].getElementsByClassName('range-slider-minus')[0];
                let range_slider_value = range_slider_containers[i].getElementsByClassName('range-slider-display-value')[0];
                let max = Number(range_slider.getAttribute('max'));
                let min = Number(range_slider.getAttribute('min'));
                let step = Number(range_slider.getAttribute('step'));
                let disable_check = function(value) {
                    if(value >= max) {
                        plus_button.classList.add('ai-disabled');
                        plus_button.setAttribute('disabled', 'disabled');
                        minus_button.removeAttribute('disabled', 'disabled');
                    } else if(value <= min) {
                        minus_button.classList.add('ai-disabled');
                        minus_button.setAttribute('disabled', 'disabled');
                        plus_button.removeAttribute('disabled', 'disabled');
                    } else {
                        plus_button.classList.remove('ai-disabled');
                        minus_button.classList.remove('ai-disabled');
                        plus_button.removeAttribute('disabled', 'disabled');
                        minus_button.removeAttribute('disabled', 'disabled');
                    }
                }
                range_slider.addEventListener('input', function(e) {
                    let value = this.value;
                    range_slider.setAttribute('value', value);
                    range_slider.value= value;
                    range_slider_value.setAttribute('value', value);
                    disable_check(value);
                });
                plus_button.addEventListener('click', function(e) {
                    e.preventDefault();
                    let value = Number(range_slider_value.getAttribute('value'));
                    let new_value = value + step;
                    if(new_value >= max) {
                        new_value = max;
                    } else {
                        range_slider.stepUp();
                    }
                    disable_check(new_value);
                    range_slider_value.setAttribute('value', new_value);
                    range_slider.setAttribute('value', new_value);
                    range_slider.dispatchEvent(new Event('change', { 'bubbles': true }));
                });
                minus_button.addEventListener('click', function(e) {
                    e.preventDefault();
                    let value = Number(range_slider_value.getAttribute('value'));
                    let new_value = value - step;
                    if(new_value <= min) {
                        new_value = min;
                    } else {
                        range_slider.stepDown();
                    }
                    disable_check(new_value);
                    range_slider_value.setAttribute('value', new_value);
                    range_slider.setAttribute('value', new_value);
                    range_slider.dispatchEvent(new Event('change', { 'bubbles': true }));
                });
            }
        }
    }
}
const ai_form_fields_init = function() {
    new AI_Form_Fields();
};

// Scrolling for linear content
/*
class AI_Horizontal_Scroll {
    constructor() {
        this.header_clearance = 0;
        let linear_content = document.getElementsByClassName('linear-content-blocks');
        if(linear_content) {
            let header = document.getElementById('ai-header');
            if(header) {
                this.header_clearance = header.offsetTop + header.offsetHeight;
            }
            for(let i = 0; i < linear_content.length; i++) {
                this.change_scroll_direction(linear_content[i]);
                this.nav_buttons(linear_content[i]);
                this.update_indicator(linear_content[i]);
            }
        }
    }
    change_scroll_direction(content_wrapper) {
        if('onwheel' in window) {
            content_wrapper.addEventListener('wheel', (e) => {
                // Set a threshold for concidering the panel to be "in view"
                let panel_in_view = Math.abs(content_wrapper.getBoundingClientRect().top - this.header_clearance) <= 30 || Math.abs(content_wrapper.getBoundingClientRect().bottom - window.innerHeight) <= 30;
                if(
                    // If the beginning of the linear content, scrolling up
                    (content_wrapper.scrollLeft <= 0 && e.wheelDelta > 0) ||
                    // or the end of the linear content, scrolling down
                    (content_wrapper.scrollLeft >= content_wrapper.scrollLeftMax && e.wheelDelta <= 0) ||
                    // or the panel isn't in view
                    ! panel_in_view
                ) {
                    // Act normal
                    return true;
                }
                // For everything in between, scroll left and right
                else {
                    e.preventDefault();
                    content_wrapper.scrollLeft += e.deltaY;
                }
            });
        } else {
            content_wrapper.classList.add('show-scroll');
            content_wrapper.parentElement.nextElementSibling.classList.add('show-scroll');
        }
    }
    update_indicator(content_wrapper) {
        let content_nav = content_wrapper.nextElementSibling;
        let style_attribute = content_nav.getAttribute('style');
        let increment = style_attribute ? style_attribute.replace('--linear-content-nav-width: ', '').replace('%;', '') : 0;
        content_wrapper.addEventListener('transitionend', (e) => {
            let indicator_width = (content_wrapper.scrollLeft / content_wrapper.scrollLeftMax) * 100;
            if(indicator_width > increment) {
                content_nav.setAttribute('style', '--linear-content-nav-width: '+indicator_width+'%;');
            }
        });
    }
    nav_buttons(content_wrapper) {
        let linear_nav = content_wrapper.parentElement.nextElementSibling;
        let linear_nav_links = linear_nav.getElementsByTagName('a');
        if(linear_nav_links) {
            for(let i = 0; i < linear_nav_links.length; i++) {
                linear_nav_links[i].addEventListener('click', this.nav_button_onclick.bind(this));
            }
        }
    }
    nav_button_onclick(e) {
        e.preventDefault();
        let target_block_id = e.currentTarget.getAttribute('href').replace('#', '');
        let target_block = document.getElementById(target_block_id);
        let content_wrapper = target_block.parentElement;
        content_wrapper.scrollLeft = target_block.offsetLeft;
    }
}
const ai_horizontal_scroll_init = function() {
    new AI_Horizontal_Scroll();
};
*/

class AI_Linear_Content {
    constructor() {
        let linear_content_sliders = document.getElementsByClassName('linear-content-blocks');
        if(linear_content_sliders) {
            for(let i = 0; i < linear_content_sliders.length; i++) {
                this.update_indicator(linear_content_sliders[i]);
            }
        }
    }
    update_indicator(content_slider) {
        let content_nav = content_slider.nextElementSibling;
        let style_attribute = content_nav.getAttribute('style');
        let increment = style_attribute ? Number(style_attribute.replace('--linear-content-nav-width: ', '').replace('%;', '')) : 0;
        UIkit.util.on(content_slider, 'itemshow', function(e) {
            let content_block = e.target;
            let content_block_index = Number(content_block.getAttribute('data-index'));
            let indicator_width = (content_block_index + 1) * increment;
            if(indicator_width >= increment) {
                content_nav.setAttribute('style', '--linear-content-nav-width: '+indicator_width+'%;');
            }
        });
    }
}
const ai_linear_content_init = function() {
    new AI_Linear_Content();
};

// Paging functionality
class AI_Load_More {
    constructor(results_wrapper_id, next_url, button) {
        // Vars
        this.results_wrapper_id = results_wrapper_id;
        this.load_more_wrapper_id = 'ai-load-more-wrapper';
        this.load_more_id = 'ai-load-more';
        if(next_url) {
            this.url = next_url;
        } else {
            let next_url_link = document.getElementsByClassName('ai-paging-next');
            this.url = next_url_link.length ? next_url_link[0].parentElement.getAttribute('href') : false;
        }

        // Remove nav
        let nav_above = document.getElementById('nav-above');
        let nav_below = document.getElementById('nav-below');
        if(nav_above){
            nav_above.parentNode.removeChild(nav_above);
        }
        if(nav_below) {
            nav_below.parentNode.removeChild(nav_below);
        }

        // Initialize the button
        this.button_setup();
    }

    button_setup() {
        let results_wrapper = document.getElementById(this.results_wrapper_id);
        // If the button already exists, remove it
        if(document.getElementById(this.load_more_wrapper_id)) {
            let load_more_wrapper = document.getElementById(this.load_more_wrapper_id);
            load_more_wrapper.parentNode.removeChild(load_more_wrapper);
        }
        if(this.url) {
            // Create a new button
            results_wrapper.insertAdjacentHTML('afterend', `<p id="${this.load_more_wrapper_id}"><a href="${this.url}" id="${this.load_more_id}" class="button color-border"><span>Load More</span></a></p>`);
            let load_more = document.getElementById(this.load_more_id);
            // Add click event to the button
            load_more.addEventListener('click', this.button_click.bind(this));
        }
    }

    button_click(e) {
        e.preventDefault();
        this.get_results();
    }

    get_results() {
        ajax_load({
            from: this.results_wrapper_id,
            url: this.url,
            scroll: false,
            append: true,
            loading_element_id: 'ai-load-more',
        });
    }
};
const ai_load_more_init = function() {
    if(document.getElementById('search-results-wrapper')) {
        new AI_Load_More('search-results-wrapper');
    }
};

// Mobile menu
class AI_Mobile_Menu {
    constructor() {
        // Elements
        this.navbar_menu = document.getElementById('ai-navbar-menu');
        this.menu_button = document.getElementById('ai-navbar-open');
        this.close_menu_button = document.getElementById('ai-navbar-close');
        this.dropdown_menu_buttons = document.getElementsByClassName('ai-navbar-dropdown');
        // Methods
        if(this.navbar_menu) {
            if(this.menu_button) {
                this.menu_button.addEventListener('click', this.show_toggle.bind(null, this.menu_button, this.navbar_menu));
            }
            if(this.close_menu_button) {
                this.close_menu_button.addEventListener('click', this.close.bind(null, this.menu_button, this.navbar_menu));
            }
            if(this.dropdown_menu_buttons.length) {
                this.dropdowns(this.dropdown_menu_buttons);
            }
        }
    }

    show_toggle(menu_button, navbar_menu) {
        // Currently open
        if(menu_button.classList.contains('open')) {
            navbar_menu.classList.remove('open');
            menu_button.classList.remove('open');
        }
        // Currently closed
        else {
            navbar_menu.classList.add('open');
            menu_button.classList.add('open');
        }
    }

    close(menu_button, navbar_menu) {
        navbar_menu.classList.remove('open');
        menu_button.classList.remove('open');
    }

    dropdowns(dropdown_buttons) {
        for(let i = 0; i < dropdown_buttons.length; i++) {
            dropdown_buttons[i].addEventListener('click', function(e) {
                let parent_li = this.parentElement;
                // Currently open
                if(this.classList.contains('open')) {
                    parent_li.classList.remove('open');
                    this.classList.remove('open');
                }
                // Currently closed
                else {
                    // Close all others
                    for(let j = 0; j < dropdown_buttons.length; j++) {
                        dropdown_buttons[j].classList.remove('open');
                        dropdown_buttons[j].parentElement.classList.remove('open');
                    }
                    // Open this one
                    parent_li.classList.add('open');
                    this.classList.add('open');
                }
            });
        }
    }
}
const ai_mobile_menu_init = function() {
    new AI_Mobile_Menu();
};
ai_document_ready(ai_mobile_menu_init);

// Custom modal handling
// Custom 'modal_open' event
const modal_open_event = new Event('modal_open');
class AI_Modal {
    constructor() {
        // Get all the modals
        let ai_modals_wrappers = document.getElementsByClassName('ai-modals');
        let ai_modals = document.getElementsByClassName('ai-modal');
        if(ai_modals_wrappers) {
            this.modals_in_wrapper(ai_modals_wrappers);
        }
        if(ai_modals) {
            this.modals(ai_modals);
        }
    }
    modals_in_wrapper(ai_modals_wrappers) {
        for(let i = 0; i < ai_modals_wrappers.length; i++) {
            let modals = ai_modals_wrappers[i];
            let a_tags = modals.getElementsByTagName('a');
            modals.setAttribute('uk-lightbox', '');
            for(let j = 0; j < a_tags.length; j++) {
                let a_tag = a_tags[j];
                let href = a_tag.getAttribute('href');
                if(href.indexOf('http') == -1 && href.indexOf('/iframe') == -1) {
                    a_tag.setAttribute('href', '/iframe'+href);
                }
                if(href.indexOf('vimeo') == -1) {
                    a_tag.setAttribute('data-type', 'iframe');
                }
            }
        }
    }
    modals(ai_modals) {
        for(let i = 0; i < ai_modals.length; i++) {
            let modal = ai_modals[i];
            let href = modal.getAttribute('href').replace(relative_home_url, '');
            let no_modal = false;
            // If relative url or local url or vimeo video or 3rd party cookies allowed
            if(href.indexOf('http') == -1 || href.indexOf(root_url) > -1 || href.indexOf('vimeo') > -1 || thirdpartycookies == 1) {
                // If not an image or pdf
                if(href.indexOf('.jpg') == -1 && href.indexOf('.jpeg') == -1 && href.indexOf('.png') == -1 && href.indexOf('.pdf') == -1) {

                    // If relative url
                    if(href.indexOf('http') == -1) {
                        // If no iframe parameter
                        if(href.indexOf('/iframe') == -1) {
                            // Add iframe parameter to url
                            modal.setAttribute('href', relative_home_url+'/iframe'+href);
                        }
                        // If there's already an iframe parameter and no 3rd party cookies allowed, add a target _blank and get outta here
                        else if(thirdpartycookies != 1) {
                            modal.setAttribute('target', '_blank');
                            no_modal = true;
                        }
                    }
                }
                // If we're proceeding with the modal, lightbox element hasn't been added yet
                if(!no_modal && !modal.classList.contains('ai-modal-window')) {
                    modal.classList.add('ai-modal-window');
                }
            }
        }
        this.modal_window();
    }
    modal_window() {
        // Get all the modals
        let ai_modal_windows = document.getElementsByClassName('ai-modal-window');
        if(ai_modal_windows) {
            for(let i = 0; i < ai_modal_windows.length; i++) {
                let modal_window = ai_modal_windows[i];
                modal_window.addEventListener('click', function(e) {
                    e.preventDefault();
                    let url = this.getAttribute('href');
                    let url_type = this.getAttribute('data-url-type') ? this.getAttribute('data-url-type') : false;
                    let modal_class = this.getAttribute('data-modal-class') ? this.getAttribute('data-modal-class') : false;
                    let iframe_name = this.getAttribute('data-iframe-name') ? this.getAttribute('data-iframe-name') : false;
                    // Build the modal
                    let modal_wrapper = document.createElement('div');
                    let modal_inner_wrapper = document.createElement('div');
                    let close_button = document.createElement('button');
                    let close_button_text = document.createElement('span');
                    modal_wrapper.setAttribute('class', 'ai-modal-window-wrapper ' + url_type);
                    if(modal_class) {
                        modal_wrapper.classList.add(modal_class);
                    }
                    modal_inner_wrapper.setAttribute('class', 'ai-modal-window-inner-wrapper');
                    close_button.setAttribute('class', 'ai-modal-window-close');
                    close_button_text.textContent = 'Close';
                    close_button.appendChild(close_button_text);
                    close_button.addEventListener('click', function(e) {
                        modal_wrapper.remove();
                    });
                    modal_inner_wrapper.appendChild(close_button);
                    modal_wrapper.appendChild(modal_inner_wrapper);
                    switch(url_type) {
                        case 'image':

                            break;
                        case 'video':
                            let modal_video = document.createElement('figure');
                            let modal_video_iframe = document.createElement('iframe');
                            modal_inner_wrapper.classList.add('ai-video-wrapper');
                            modal_video.setAttribute('class', 'ai-video');
                            modal_video_iframe.setAttribute('src', url);
                            modal_video_iframe.setAttribute('frameborder', '0');
                            modal_video_iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
                            modal_video_iframe.setAttribute('allowfullscreen', '');
                            if(iframe_name) {
                                modal_video_iframe.setAttribute('name', iframe_name);
                            }
                            modal_video.appendChild(modal_video_iframe);
                            modal_inner_wrapper.appendChild(modal_video);
                            break;
                        default:
                            let modal_iframe_wrapper = document.createElement('div');
                            let modal_iframe = document.createElement('iframe');
                            modal_iframe_wrapper.setAttribute('class', 'ai-iframe-wrapper');
                            modal_iframe.setAttribute('src', url);
                            modal_iframe.setAttribute('frameborder', '0');
                            if(iframe_name) {
                                modal_iframe.setAttribute('name', iframe_name);
                            }
                            // Downloadable Content
                            let downloadable_wrapper_top;
                            let downloadable_wrapper_bottom;
                            if(modal_class && modal_class == 'ai-downloadable-content') {
                                // Wrappers
                                downloadable_wrapper_top = document.createElement('div');
                                downloadable_wrapper_top.setAttribute('class', 'ai-downloadable top');
                                downloadable_wrapper_bottom = document.createElement('div');
                                downloadable_wrapper_bottom.setAttribute('class', 'ai-downloadable bottom');
                                // Contact Button
                                let downloadable_contact_us = downloadable.contact;
                                // Site updates form
                                let downloadable_site_updates = downloadable.site_updates;
                                // Survey
                                let downloadable_survey = downloadable.survey;
                                // Place it
                                downloadable_wrapper_top.innerHTML = downloadable_site_updates + downloadable_contact_us;
                                downloadable_wrapper_bottom.innerHTML = downloadable_survey;
                                modal_inner_wrapper.appendChild(downloadable_wrapper_top);
                            }
                            modal_iframe_wrapper.appendChild(modal_iframe);
                            modal_inner_wrapper.appendChild(modal_iframe_wrapper);
                            if(modal_class && modal_class == 'ai-downloadable-content') {
                                modal_inner_wrapper.appendChild(downloadable_wrapper_bottom);
                            }
                            break;
                    }
                    document.body.appendChild(modal_wrapper);
                    close_button.focus();
                    document.dispatchEvent(modal_open_event);
                });
            }
        }
    }
}
const ai_modal_init = function() {
    new AI_Modal();
};

// Select List
class AI_Select_List {
    constructor() {
        let select_list_toggles = document.getElementsByClassName('select-list-toggle');
        if(select_list_toggles) {
            for(let i = 0; i < select_list_toggles.length; i++) {
                let select_list = select_list_toggles[i];
                // First remove the event listener, just in case, then add it back
                select_list.removeEventListener('click', this.onclick);
                select_list.addEventListener('click', this.onclick);
                // If this is tabs, do more things
                if(select_list.classList.contains('tabs-nav-toggle')) {
                    let tab_list = select_list.nextElementSibling;
                    tab_list.removeEventListener('click', this.tab_onclick);
                    tab_list.addEventListener('click', this.tab_onclick);
                }
            }
        }
    }

    onclick(e) {
        let select_list_to_toggle_id = this.getAttribute('data-toggle');
        let select_list_to_toggle = select_list_to_toggle_id ? document.getElementById(select_list_to_toggle_id) : this.nextElementSibling;
        // Already open
        if(this.classList.contains('open')) {
            this.classList.remove('open');
            select_list_to_toggle.classList.remove('open');
        }
        // Already closed
        else {
            this.classList.add('open');
            select_list_to_toggle.classList.add('open');
        }
    }

    tab_onclick(e) {
        let current_target = e.target;
        let parent_li = current_target.parentElement;
        let parent_ul = parent_li.parentElement;
        let select_list = parent_ul.previousElementSibling;
        // Close select list
        if(select_list) {
            parent_ul.classList.remove('open');
            select_list.classList.remove('open');
            select_list.innerHTML = current_target.textContent;
        }
    }
}
const ai_select_list_init = function() {
    new AI_Select_List();
};

class AI_Table_of_Contents {
    constructor() {
        this.toc_toggle_button = document.getElementById('ai-toc-toggle');
        if(this.toc_toggle_button) {
            this.toc_nav = document.getElementById('ai-table-of-contents');
            this.toc_toggle_button_text_element = this.toc_toggle_button.getElementsByTagName('span')[0];
            this.toc_toggle_button_open_text = this.toc_toggle_button.getAttribute('data-open-text');
            this.toc_toggle_button_close_text = this.toc_toggle_button.getAttribute('data-close-text');
            this.toc_toggle_button.addEventListener('click', this.toggle.bind(this));
            document.addEventListener('scroll', this.tooltip.bind(this));
        }
    }

    toggle(e) {
        if(this.toc_nav.classList.contains('open')) {
            this.toc_nav.classList.remove('open');
            this.toc_toggle_button_text_element.innerText = this.toc_toggle_button_open_text;
        } else {
            this.toc_nav.classList.add('open');
            this.toc_toggle_button_text_element.innerText = this.toc_toggle_button_close_text;
        }
    }

    tooltip(e) {
        let window_scroll_y = window.scrollY;
        let window_height = window.innerHeight;
        if(window_scroll_y > (window_height * 2)) {
            this.toc_toggle_button.classList.remove('show');
            this.toc_toggle_button_text_element.innerText = this.toc_toggle_button_open_text;
        }
    }
}
const ai_toc_init = function() {
    new AI_Table_of_Contents();
};
ai_document_ready(ai_toc_init);

const ai_version_transition = function() {
    let body = document.body;
    if(body.classList.contains('has-versions')) {
        let versions = body.getAttribute('data-versions');
        let current_version = 1;
        let previous_version = 0;
        let change_version = setInterval(function() {
            if(body.classList.contains('version-'+previous_version)) {
                body.classList.remove('version-'+previous_version);
            }
            body.classList.add('version-'+current_version);
            previous_version = current_version;
            if(current_version < versions) {
                current_version++;
            } else {
                current_version = 1;
            }
        }, 8000);
    }
}
ai_document_ready(ai_version_transition);

class AI_Videos {
    constructor() {
        let video_navs = document.getElementsByClassName('video-nav');
        let video_players = document.getElementsByClassName('video-player');
        this.player;
        this.player_options = {
            title: 0,
            byline: 0,
            portrait: 0
        };
        if(video_navs.length) {
            for(let i = 0; i < video_navs.length; i++) {
                video_navs[i].removeEventListener('click', this.navigation.bind(this));
                video_navs[i].addEventListener('click', this.navigation.bind(this));
            }
        }
        if(video_players.length) {
            this.load_all();
        }
    }

    navigation(e) {
        e.preventDefault();
        let current_target = get_anchor_tag(e.target);
        let url = current_target.getAttribute('data-video-url');
        let index = current_target.getAttribute('data-video-index');
        let player_number = current_target.getAttribute('data-player-number');
        let texttrack = current_target.getAttribute('data-video-texttrack');
        let player_div = document.getElementById('video-player-'+player_number);
        let parent_li = current_target.parentElement;
        let parent_ul = parent_li.parentElement;
        let select_list = parent_ul.previousElementSibling;
        let active_li = parent_ul.getElementsByClassName('active');
        // remove active class
        for (let i = 0; i < active_li.length; i++) {
            active_li[i].classList.remove('active');
        }
        // make current active
        parent_li.classList.add('active');
        // Close select list
        if(select_list) {
            parent_ul.classList.remove('open');
            select_list.classList.remove('open');
            select_list.innerHTML = current_target.textContent;
        }
        // Update video index and url
        player_div.setAttribute('data-video-index', index);
        player_div.setAttribute('data-video-url', url);
        player_div.setAttribute('data-video-texttrack', texttrack);
        // Load and play the video
        if (typeof Vimeo !== 'undefined') {
            if(typeof this.player.destroy =='function') {
                this.player.destroy().then(this.load_and_play.bind(this, player_div, url)).catch(function(error) {
                    // an error occurred
                });
            } else {
                this.load_and_play(player_div, url);
            }
        } else {
            new AI_Video_Fallback(player_div);
        }
    }

    play_next(player_div, data) {
        if (data.percent == 1) {
            let current_video_index = Number(player_div.getAttribute('data-video-index'));
            let next_video_index = current_video_index + 1;
            let player_number = player_div.getAttribute('data-player-number');
            let current_video_nav_li = document.getElementById('video-nav-'+player_number+'-'+current_video_index).parentElement;
            let next_video = window['video_list_' + player_number][next_video_index] ? window['video_list_' + player_number][next_video_index] : false;
            current_video_nav_li.classList.remove('active');
            if (next_video) {
                let next_video_nav_li = document.getElementById('video-nav-'+player_number+'-'+next_video_index).parentElement;
                next_video_nav_li.classList.add('active');
                player_div.setAttribute('data-video-index', next_video_index);
                // Load and play the video
                if (typeof Vimeo !== 'undefined') {
                    this.player.destroy().then(this.load_and_play.bind(this, player_div, next_video)).catch(function(error) {
                        // an error occurred
                    });
                } else {
                    new AI_Video_Fallback(player_div);
                }
            } else {
                let first_video_nav_li = document.getElementById('video-nav-'+player_number+'-0').parentElement;
                first_video_nav_li.classList.add('active');
                player_div.setAttribute('data-video-index', 0);
                player.loadVideo({
                    url: window['video_list_'+player_number][0],
                    autoplay: 0,
                    texttrack: player_div.getAttribute('data-video-texttrack')
                });
            }
        }
    }

    load_all() {
        let settings = {
            class_name: 'video-player',
            initial_attribute: false,
            load_attribute: false,
            callback: function(player_div) {
                if (player_div && typeof Vimeo !== 'undefined') {
                    player_div.classList.add('video-player');
                    this.player_options.url = player_div.getAttribute('data-video-url');
                    this.player_options.texttrack = player_div.getAttribute('data-video-texttrack');
                    this.player = new Vimeo.Player(player_div, this.player_options);
                    this.player.on('ended', this.play_next.bind(this, player_div));
                }
            }.bind(this),
        };
        load_defered_elements(settings);
    }

    load_and_play(player_div, url) {
        this.player_options.texttrack = player_div.getAttribute('data-video-texttrack');
        this.player = new Vimeo.Player(player_div, this.player_options);
        this.player.loadVideo({
            url: url,
            autoplay: 1,
            texttrack: this.player_options.texttrack,
        });
        this.player.on('ended', this.play_next.bind(this, player_div));
    }
}
const ai_videos_init = function() {
    new AI_Videos();
};

// Image/link fallback for Vimeo videos
class AI_Video_Fallback {
    constructor(player) {
        if (typeof Vimeo == 'undefined') {
            // Specific player
            if(player) {
                this.fallback_image(player);
            }
            // All players
            else {
                let vimeo_players = document.getElementsByClassName('video-player');
                for (let i = 0; i < vimeo_players.length; i++) {
                    let player = vimeo_players[i];
                    this.fallback_image(player);
                }
            }
        }
    }
    fallback_image(player) {
        let vimeo_url = player.getAttribute('data-vimeo-url');
        let vimeo_id_array = vimeo_url.match(/[\d]+/);
        if(vimeo_id_array && vimeo_id_array.length) {
            let vimeo_id = vimeo_id_array[0];
            let xhr = new XMLHttpRequest();
            xhr.addEventListener('readystatechange', function() {
                if(this.readyState === 4) {
                    // Set a default fallback image and url
                    let fallback_image = home_url+'/wp-content/themes/amelia-core/images/video-fallback.jpg';
                    let fallback_url = vimeo_url;
                    let response = JSON.parse(this.responseText);
                    if(!response.error) {
                        // Get url from api
                        fallback_url = response.link;
                        let images = response.pictures.sizes;
                        for (let i = 0; i < images.length; i++) {
                            if(images[i].width == 640) {
                                // Get image from api
                                fallback_image = images[i].link_with_play_button;
                            }
                        }
                    }
                    // Implement fallback image and modal window
                    player.innerHTML = `<a href="${fallback_url}" target="_blank">
                        <img src="${fallback_image}" class="video-fallback-image">
                    </a>`;
                }
            });
            xhr.open('GET', 'https://api.vimeo.com/videos/'+vimeo_id);
            xhr.setRequestHeader('Accept', 'application/vnd.vimeo.*+json;version=3.4');
            //xhr.setRequestHeader('Authorization', 'Bearer 14a66e9f4e0dd3199202f310fc059f9f');
            xhr.setRequestHeader('Authorization', 'Bearer 5732c382a11339333d186905d7efeb3a');
            xhr.send();
        }
    }
}
const ai_video_fallback_init = function() {
    new AI_Video_Fallback();
};
ai_document_ready(ai_video_fallback_init);

class AI_Video_Controls {
    constructor() {
        let embedded_videos = document.getElementsByClassName('ai-embedded-video-controls');
        if(embedded_videos) {
            for(let i = 0; i < embedded_videos.length; i++) {
                this.add_controls(embedded_videos[i]);
            }
        }
    }
    add_controls(video) {
        let controls_id = 'ai-controls-' + Math.floor((Math.random() * 100) + 1);
        video.removeAttribute('controls');
        video.parentElement.insertAdjacentHTML('afterend', `<div class="ai-controls-wrapper" id="${controls_id}-wrapper"></div>`);
        let controls_wrapper = document.getElementById(controls_id+'-wrapper');
        // Display buttons
        controls_wrapper.innerHTML = controls_wrapper.innerHTML + `<button class="ai-control rewind" id="${controls_id}-rewind"><span>Rewind</span></button>`;
        controls_wrapper.innerHTML = controls_wrapper.innerHTML + `<button class="ai-control pause" id="${controls_id}-playpause"><span>Pause</span></button>`;
        controls_wrapper.innerHTML = controls_wrapper.innerHTML + `<button class="ai-control forward" id="${controls_id}-forward"><span>Forward</span></button>`;
        // Declare button objects
        let rewind_button = document.getElementById(controls_id+'-rewind');
        let play_pause_button = document.getElementById(controls_id+'-playpause');
        let forward_button = document.getElementById(controls_id+'-forward');
        // Add event listeners
        rewind_button.addEventListener('click', this.rewind_onclick.bind(null, video));
        play_pause_button.addEventListener('click', this.play_pause_onclick.bind(null, video, play_pause_button));
        forward_button.addEventListener('click', this.forward_onclick.bind(null, video, play_pause_button));
        video.addEventListener('ended', this.onended.bind(null, video, play_pause_button));
    }
    play_pause_onclick(video, play_pause_button) {
        if(video.paused) {
            video.play();
            play_pause_button.classList.remove('play');
            play_pause_button.classList.add('pause');
            play_pause_button.innerHTML = '<span>Pause</span>';
        } else {
            video.pause();
            play_pause_button.classList.remove('pause');
            play_pause_button.classList.add('play');
            play_pause_button.innerHTML = '<span>Play</span>';
        }
    }
    onended(video, play_pause_button) {
        play_pause_button.classList.remove('pause');
        play_pause_button.classList.add('play');
        play_pause_button.innerHTML = '<span>Play</span>';
        // Execute a callback, if there is one
        let video_file_array = video.firstElementChild.getAttribute('src').split('/');
        let video_file_name_array = video_file_array[video_file_array.length - 1].split('.');
        let video_name = video_file_name_array[0];
        if(typeof window[ video_name + '_video_end_callback'] == 'function' ) {
            eval(video_name + '_video_end_callback(video)');
        }
    }
    forward_onclick(video, play_pause_button) {
        video.currentTime += 3;
        if(video.currentTime >= video.duration) {
            video.pause();
            play_pause_button.classList.remove('pause');
            play_pause_button.classList.add('play');
            play_pause_button.innerHTML = '<span>Play</span>';
        }
    }
    rewind_onclick(video) {
        video.currentTime -= 3;
    }
}
const ai_video_controls_init = function() {
    new AI_Video_Controls();
};

// Unload a video when it is hidden, load it when visible again
class AI_Videos_In_Tabs {
    constructor() {
        this.saved_videos = {};
        let has_video_elements = document.getElementsByClassName('has-video');
        if(has_video_elements.length) {
            for(let i = 0; i < has_video_elements.length; i++) {
                this.watch_visibility(has_video_elements[i]);
            }
        }
    }

    watch_visibility($obj) {
        let observer = new MutationObserver(function(){
            if($obj.classList.contains('uk-active') == false) {
                let video_player = $obj.getElementsByClassName('video-player');
                for(let i = 0; i < video_player.length; i++) {
                    let player_id = video_player[i].getAttribute('id');
                    if(player_id) {
                        this.saved_videos[player_id] = video_player[i].innerHTML;
                    }
                    video_player[i].innerHTML = '';
                }
            } else {
                let video_player = $obj.getElementsByClassName('video-player');
                for(let i = 0; i < video_player.length; i++) {
                    let player_id = video_player[i].getAttribute('id');
                    if(player_id && this.saved_videos[player_id]) {
                        video_player[i].innerHTML = this.saved_videos[player_id];
                    }
                }
            }
        }.bind(this));
        observer.observe($obj, {
            attributes: true,
            childList: true,
            attributeFilter: ['style', 'class'],
        });
    }
}
const ai_videos_in_tabs_init = function() {
    new AI_Videos_In_Tabs();
};
ai_document_ready(ai_videos_in_tabs_init);

const window_onload = function() {
    load_defered_bg_video();
    load_defered_charts();
    load_defered_elements();
    load_defered_forms();
    load_defered_iframes();
    load_defered_twitter();
    ai_linear_content_init();
    ai_load_more_init();
    ai_modal_init();
    ai_select_list_init();
    ai_video_controls_init();
    ai_videos_init();
}

window.onload = function() {
    window_onload();
}

document.addEventListener('modal_open', function() {
    ai_content_survey_init();
    ai_downloadable_contact_button_init();
    ai_form_init();
});